var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "MobileContainer",
    [
      _c(
        "MobileHeader",
        {
          attrs: {
            slot: "header",
            "nav-action": "home",
            "show-logout-btn": ""
          },
          slot: "header"
        },
        [_vm._v("\n    My Profile\n  ")]
      ),
      _vm._v(" "),
      _c("UserAccount"),
      _vm._v(" "),
      _c(
        "MobileButton",
        {
          class: _vm.$style.editProfileBtn,
          attrs: {
            slot: "footer",
            to: { name: "edit-user-profile" },
            square: ""
          },
          slot: "footer"
        },
        [_vm._v("\n    Edit Profile\n  ")]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/apps/mobile/components/MobileUserAccount.vue?vue&type=template&id=4ddae990&
// module id = null
// module chunks = 